import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import clsx from 'clsx';

export type Props = ButtonProps & {
  overlay?: boolean;
  colorType?: 'primary' | 'dangerous' | 'default';
  additionalClassName?: string;
};

const useStyles = makeStyles(() => createStyles({
  button: {
    fontSize: 16,
    height: 32,
    textTransform: 'unset',
    paddingTop: 2,
    paddingBottom: 2,
    color: '#01B3C5',
    borderColor: '#01B3C5',
    fontWeight: 700,
    whiteSpace: 'nowrap',

    '& +button': {
      marginLeft: 16,
    },
  },
  buttonContained: {
    color: '#FFFFFF',
    background: '#01B3C5',

    '&:hover': {
      background: '#018d9f',
    },
  },
  defaultContained: {
    color: '#26325F',
    background: '#F1F2F5',

    '&:hover': {
      background: '#eaebee',
    },
  },
  redButton: {
    color: '#F8221A',
    borderColor: '#F8221A',
  },
}), { name: 'SimpleButton' });


const SimpleButton = ({
  colorType = 'primary',
  onClick,
  children,
  variant = 'outlined',
  additionalClassName = '',
  ...props
}: Props) => {
  const nativeClasses = useStyles();

  return (
    <Button
      onClick={onClick}
      className={clsx(nativeClasses.button, additionalClassName, {
        [nativeClasses.redButton]: colorType === 'dangerous',
        [nativeClasses.buttonContained]: variant === 'contained',
        [nativeClasses.defaultContained]: (variant === 'contained' && colorType === 'default'),
      })}
      variant={variant}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SimpleButton;
